import React from "react";
import AuthService from "services/auth.service";
import { useLocation } from "react-router-dom";
import { API_URL_IMAGE } from "../../services/config";
import routes from "routes.js";
import defaultImage from "../../assets/img/default-avatar.png";
import ThemeToggle from "components/ThemeToggle";
import styles from "./DemoNavbar.module.css";

function Header(props) {
  const currentUser = AuthService.getCurrentUser();
  const location = useLocation();
  const sidebarToggle = React.useRef();

  const getBrand = () => {
    let brandName = "Dashboard";
    routes.map((prop) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        brandName = prop.name;
      }
      return null;
    });
    return brandName;
  };

  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };

  const imageDir = currentUser?.imageURL;
  let profileImage = `${API_URL_IMAGE}${imageDir}`;
  if (profileImage.endsWith("none")) profileImage = defaultImage;

  return (
    <nav className={styles.navbar}>
      <div className={styles.left}>
        {/* Sidebar toggle (mobile) */}
        <button
          type="button"
          ref={sidebarToggle}
          className={styles.hamburger}
          onClick={openSidebar}
          aria-label="Toggle sidebar"
        >
          <span />
          <span />
          <span />
        </button>

        {/* Page title */}
        <span className={styles.brand}>{getBrand()}</span>
      </div>

      <div className={styles.right}>
        <ThemeToggle />

        <div className={styles.userArea}>
          <img
            src={profileImage}
            alt="Profile"
            className={styles.avatar}
          />
          <span className={styles.userName}>{currentUser?.firstName}</span>
        </div>
      </div>
    </nav>
  );
}

export default Header;